import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45token_45login_45global from "/app/middleware/01.token-login.global.ts";
import auth_45global from "/app/middleware/auth.global.ts";
import navigation_45guard_45global from "/app/middleware/navigation-guard.global.ts";
import preload_45global from "/app/middleware/preload.global.ts";
import redirect_45global from "/app/middleware/redirect.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45token_45login_45global,
  auth_45global,
  navigation_45guard_45global,
  preload_45global,
  redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}